import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section_novel p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/novelcraft/intro_img.webp"
              alt="TekRevol Novelcraft"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={565}
              height={291}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-lg-1 order-md-2 order-1"
          >
            <h2>Introduction to Game Story</h2>
            <p>
              Novelcraft centers on two main characters, Travis and Abby, and
              each episode lets you make an intriguing choice that shapes the
              course of the game that will keep you at the edge of your seat
              till the very end.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
